import { ComponentType as T } from "../../registries/types/propTypes.js";
import { Video as f } from "../../../components/VideoSection/types/propsTypes.js";
const w = (p) => {
  var u, o, e, y, _;
  const r = Array.isArray(p == null ? void 0 : p.video_section) ? p == null ? void 0 : p.video_section[0] : p == null ? void 0 : p.video_section, l = r == null ? void 0 : r.video_type, g = l == f.upload && (r != null && r.video) ? r == null ? void 0 : r.video.url : (u = r == null ? void 0 : r.video_url) == null ? void 0 : u.href, n = r == null ? void 0 : r.title, A = (e = (o = r == null ? void 0 : r.thumbnail) == null ? void 0 : o.images) == null ? void 0 : e.map((s) => ({
    url: s.image.url,
    altText: s.alt_text,
    viewport: s.viewport
  }));
  let m;
  if (l == f.brightcove) {
    const s = Array.isArray(r == null ? void 0 : r.brightcove) ? r == null ? void 0 : r.brightcove[0] : r == null ? void 0 : r.brightcove;
    m = {
      videoId: s == null ? void 0 : s.id,
      poster: ((_ = (y = s == null ? void 0 : s.images) == null ? void 0 : y.poster) == null ? void 0 : _.src) ?? "",
      accountId: s == null ? void 0 : s.account_id
    };
  }
  return {
    componentType: T.video_section,
    videoType: l,
    videoUrl: g,
    title: n,
    brightcove: m,
    images: A
  };
};
export {
  w as default
};
//# sourceMappingURL=video-section-transformer.js.map
